import axios, { AxiosError } from "axios";
import type {MixedContentResponseDTO} from "../Models/DTOs/CountWrapper";

const WEB_API_URL = process.env.REACT_APP_WEB_API_URL;

export interface GetMixedContentArgs {
    categoryId: number;
    take?: number;
    skip?: number;
    order?: string;
    publishedOnly?: boolean;
    signal?: AbortSignal;
}

export async function GetMixedContent(
    args: GetMixedContentArgs
): Promise<MixedContentResponseDTO> {
    if (!WEB_API_URL) throw new Error("REACT_APP_WEB_API_URL is not set.");

    const {
        categoryId,
        take = 20,
        skip = 0,
        order = "desc",
        publishedOnly = true,
        signal,
    } = args;

    return axios
        .get(`${WEB_API_URL}v2/mixed-content`, {
            params: { categoryId, take, skip, order, publishedOnly },
            signal,
        })
        .then((result) => {
            // console.log("GetMixedContent response:", result.data);
            return result.data as MixedContentResponseDTO;
        })
        .catch((error: AxiosError) => {
            // If you want to avoid noise on intentional aborts:
            // if ((error as any)?.name === "CanceledError") throw error;

            console.log("GetMixedContent error:", error);
            throw error;
        });
}
